function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module media-embed/mediaembedui
 */
import { Plugin } from 'ckeditor5/src/core';
import { createDropdown } from 'ckeditor5/src/ui';
import MediaFormView from './ui/mediaformview';
import MediaEmbedEditing from './mediaembedediting';
import mediaIcon from '../theme/icons/media.svg';
/**
 * The media embed UI plugin.
 *
 * @extends module:core/plugin~Plugin
 */

var MediaEmbedUI = /*#__PURE__*/function (_Plugin) {
  _inherits(MediaEmbedUI, _Plugin);

  var _super = _createSuper(MediaEmbedUI);

  function MediaEmbedUI() {
    _classCallCheck(this, MediaEmbedUI);

    return _super.apply(this, arguments);
  }

  _createClass(MediaEmbedUI, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var _this = this;

      var editor = this.editor;
      var command = editor.commands.get('mediaEmbed');
      var registry = editor.plugins.get(MediaEmbedEditing).registry;
      editor.ui.componentFactory.add('mediaEmbed', function (locale) {
        var dropdown = createDropdown(locale);
        var mediaForm = new MediaFormView(getFormValidators(editor.t, registry), editor.locale);

        _this._setUpDropdown(dropdown, mediaForm, command, editor);

        _this._setUpForm(dropdown, mediaForm, command);

        return dropdown;
      });
    }
    /**
     * @private
     * @param {module:ui/dropdown/dropdownview~DropdownView} dropdown
     * @param {module:ui/view~View} form
     * @param {module:media-embed/mediaembedcommand~MediaEmbedCommand} command
     */

  }, {
    key: "_setUpDropdown",
    value: function _setUpDropdown(dropdown, form, command) {
      var editor = this.editor;
      var t = editor.t;
      var button = dropdown.buttonView;
      dropdown.bind('isEnabled').to(command);
      dropdown.panelView.children.add(form);
      button.set({
        label: t('Insert media'),
        icon: mediaIcon,
        tooltip: true
      }); // Note: Use the low priority to make sure the following listener starts working after the
      // default action of the drop-down is executed (i.e. the panel showed up). Otherwise, the
      // invisible form/input cannot be focused/selected.

      button.on('open', function () {
        form.disableCssTransitions(); // Make sure that each time the panel shows up, the URL field remains in sync with the value of
        // the command. If the user typed in the input, then canceled (`urlInputView#fieldView#value` stays
        // unaltered) and re-opened it without changing the value of the media command (e.g. because they
        // didn't change the selection), they would see the old value instead of the actual value of the
        // command.

        form.url = command.value || '';
        form.urlInputView.fieldView.select();
        form.focus();
        form.enableCssTransitions();
      }, {
        priority: 'low'
      });
      dropdown.on('submit', function () {
        if (form.isValid()) {
          editor.execute('mediaEmbed', form.url);
          closeUI();
        }
      });
      dropdown.on('change:isOpen', function () {
        return form.resetFormStatus();
      });
      dropdown.on('cancel', function () {
        return closeUI();
      });

      function closeUI() {
        editor.editing.view.focus();
        dropdown.isOpen = false;
      }
    }
    /**
     * @private
     * @param {module:ui/dropdown/dropdownview~DropdownView} dropdown
     * @param {module:ui/view~View} form
     * @param {module:media-embed/mediaembedcommand~MediaEmbedCommand} command
     */

  }, {
    key: "_setUpForm",
    value: function _setUpForm(dropdown, form, command) {
      form.delegate('submit', 'cancel').to(dropdown);
      form.urlInputView.bind('value').to(command, 'value'); // Form elements should be read-only when corresponding commands are disabled.

      form.urlInputView.bind('isReadOnly').to(command, 'isEnabled', function (value) {
        return !value;
      });
    }
  }], [{
    key: "requires",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return [MediaEmbedEditing];
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "pluginName",
    get: function get() {
      return 'MediaEmbedUI';
    }
  }]);

  return MediaEmbedUI;
}(Plugin);

export { MediaEmbedUI as default };

function getFormValidators(t, registry) {
  return [function (form) {
    if (!form.url.length) {
      return t('The URL must not be empty.');
    }
  }, function (form) {
    if (!registry.hasMedia(form.url)) {
      return t('This media URL is not supported.');
    }
  }];
}